import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BeneficiariesEffects, beneficiariesReducer } from './store';

@NgModule({
  imports: [
    EffectsModule.forFeature([BeneficiariesEffects]),
    StoreModule.forFeature(`beneficiaries`, beneficiariesReducer)
  ]
})
export class BeneficiariesStateModule {}
